import React from 'react'
import { AutocompleteInputProps } from 'react-admin'
import { getCurrentLang, useLangContext } from 'services/contexts/LangContext'
import {
  parseMultilangJSON,
  translateChoices,
} from 'services/utils/multilangParseWrite'
import { SelectArrayInputProps } from 'types/common'

type Props = Omit<
  AutocompleteInputProps | AutocompleteInputProps | SelectArrayInputProps,
  'children'
> & {
  children: JSX.Element
}

const LocalizedFieldWithChoices: React.FC<Props> = ({
  choices = [],
  optionText = 'name',
  label,
  children,
  ...props
}) => {
  useLangContext()
  const currentLang = getCurrentLang()
  const translatedChoices = translateChoices(choices, optionText, currentLang)
  const translatedLabel = parseMultilangJSON(label)[currentLang]
  return React.cloneElement(children, {
    ...props,
    optionText,
    label: translatedLabel,
    choices: translatedChoices,
  })
}

export default LocalizedFieldWithChoices
